<template>
  <div class="app-container">
    <HeaderLogo />
    <div class="main-content">
      <div class="card">
        <div class="alarm-header">
          <div style="width:100%;display:flex;justify-content:space-between">
           
            <button class="btn btn-primary" @click="save">保存</button>
             <span class="link-back" @click="$router.back()">
              返回到上一页
            </span>
          </div>
          <div class="right-actions">
           
          </div>
        </div>

        <!-- First Table: Dormitory records -->
        <div class="table-box" >
          <h3>终端信息</h3>
          <div class="table-wrapper">
            <table class="table" style="height:40%">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>宿舍名称</th>
                  <th>终端 IP</th>
                  <th>终端状态</th>
                  <th>终端所在地</th>
                  <th>创建时间</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in devices" :key="index">
                  <td>{{ row.deviceId }}</td>
                  <td>
                    <div 
                      class="dorm-name" 
                      contenteditable="true"
                      @blur="updateDeviceName(row, $event)"
                    >
                      {{ row.deviceName }}
                    </div>
                  </td>
                  <td>{{ row.deviceIp }}</td>
                  <td>{{ row.status == 1 ? '在线' : '离线' }}</td>
                  <td>{{ row.deviceIocation }}</td>
                  <td>{{ row.createdAt }}</td>
                </tr>
                <tr v-if="devices.length === 0">
                  <td colspan="6">暂无更多设备</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Second Table: Device records -->
        <div class="table-box">
          <h3>编组信息</h3>
          <div class="table-wrapper">
            <table class="table">
              <thead>
                <tr>
                 <th>序号</th>
                  <th>编组名称</th>
                  <th>设备数量</th>
               <th>创建时间</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in groups" :key="row.id">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <div 
                      class="dorm-name" 
                      contenteditable="true"
                      @blur="updateGroupName(row, $event)"
                    >
                      {{ row.deviceGroupName }}
                    </div>
                  </td>
                  <td>{{ row.deviceCount }}</td>
                  <td>{{ row.createdAt }}</td>
                </tr>
                <tr v-if="groups.length === 0">
                  <td colspan="6">暂无记录</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderLogo from '@/components/HeaderLogo.vue'
import { getDeviceList,updateDeviceNames,getDeviceToGroupList,updateGroupNames } from '@/api/api'
export default {
  name: 'AlarmRecords',
  components: { HeaderLogo },
  props: {
    dormId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      devices: [],
      groups:[],
      originalDevices: [],  // 保存原始数据
      originalGroups: [],  // 保存原始数据
    
    }
  },
   mounted() {
    // ✅ 页面加载时自动请求
    this.fetchDeviceList()

  },
  methods: {
   async save() {
  try {
    const changedDeviceRows = []
    const changedGroupRows = []

    // 设备名称修改检测
    this.devices.forEach((item, index) => {
      const oldItem = this.originalDevices[index]
      if (oldItem && item.deviceName !== oldItem.deviceName) {
        changedDeviceRows.push({
          id: item.id,
          deviceName: item.deviceName
        })
      }
    })

    // 分组名称修改检测
    this.groups.forEach((item, index) => {
      const oldItem = this.originalGroups[index]
      if (oldItem && item.deviceGroupName !== oldItem.deviceGroupName) {
        changedGroupRows.push({
          id: item.id,
          deviceGroupName: item.deviceGroupName
        })
      }
    })

    // ✅ 如果两个都没改，直接返回
    if (changedDeviceRows.length === 0 && changedGroupRows.length === 0) {
      alert("没有需要保存的修改")
      return
    }

    // ✅ 并行更新（提升性能）
    const promises = []
    if (changedDeviceRows.length > 0) {
      promises.push(updateDeviceNames(changedDeviceRows))
    }
    if (changedGroupRows.length > 0) {
      promises.push(updateGroupNames(changedGroupRows))
    }

    await Promise.all(promises)

    alert("修改完成")
    await this.fetchDeviceList()
  } catch (err) {
    console.error("❌ 保存失败:", err)
   
  }
},



    updateDeviceName(row, event) {
      row.deviceName = event.target.innerText;
    },

     updateGroupName(row, event) {
      row.deviceGroupName = event.target.innerText;
    },

    async fetchDeviceList() {
  try {
    // 并行请求设备与编组信息
    const [resDevices, resGroups] = await Promise.all([
      getDeviceList(),
      getDeviceToGroupList()
    ])

    // ✅ 设备列表
    if (resDevices.code === 0 && Array.isArray(resDevices.data)) {
      this.devices = resDevices.data
      this.originalDevices = JSON.parse(JSON.stringify(resDevices.data))
    } else {
      console.warn('⚠️ 获取设备列表失败:', resDevices)
    }

    // ✅ 编组列表
    if (resGroups.code === 0 && Array.isArray(resGroups.data)) {
      this.groups = resGroups.data
      this.originalGroups = JSON.parse(JSON.stringify(resGroups.data))
    } else {
      console.warn('⚠️ 获取设备组失败:', resGroups)
    }

  } catch (err) {
    console.error('❌ fetchDeviceList 出错:', err)
  }
},


    handleSelectDorm(dorm) {
      this.selectedDorm = dorm
    }
  }
}
</script>
<style scoped>
.alarm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  gap: 12px;
  color: #e5e7eb;
}

.table-wrapper {
  height: 40%;      /* 限定最大高度，可改成你想要的值 */
  overflow-y: auto;        /* 超出时出现竖向滚动条 */
  overflow-x: hidden;      /* 不要横向滚动条 */
}

.sub-title {
  font-size: 12px;
  color: #9ca3af;
}

.main-title {
  font-size: 19px;
  font-weight: 600;
  color: #f9fafb;
}

.dorm-name {
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  outline: none; /* Remove outline on focus */
  border: none; /* Ensure no border appears */
  text-align: center; /* Horizontally center the text */
  vertical-align: middle; /* Vertically center the text */
}

.dorm-name:empty {
  color: #9ca3af; /* Light color when empty */
}

.right-actions {
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 10px;
}

.title {
  white-space: nowrap;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 8px;
}

/* 平板：高度稍微矮一点 */
@media (max-width: 1024px) {
  .table-wrapper {
    max-height: 50vh;
  }
}

/* 手机：再矮一点，避免顶到底 */
@media (max-width: 768px) {
  .table-wrapper {
    max-height: 40vh;
  }
}

.table-wrapper {
  max-height: 40vh;      /* 默认：桌面端最高占 60% 视口高度 */
  overflow-y: auto;
  overflow-x: hidden;
}

.table-box {
  margin-bottom: 0px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05); /* Subtle shadow for separation */
}

h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #4b5563; /* Darker text for better contrast */
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  text-align: center; /* Horizontally center all table content */
}

.table th, .table td {
  padding: 12px;
  text-align: center; /* Center the text in the table */
  vertical-align: middle; /* Vertically center the content */
}

@media (max-width: 768px) {
  .alarm-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .right-actions {
    align-self: stretch;
    justify-content: space-between;
  }
  .right-actions .btn {
    flex-shrink: 0;
  }
  /* Ensure tables are scrollable horizontally on smaller screens */
  .table-wrapper {
    overflow-x: scroll;
  }
}
</style>
